import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import { checkUserPermission } from "../../common/UserPermission";
import config from "../../config/config";
// import DataTable from "react-data-table-component";
import LookupReceiptSaleModal from "../Modal/LookupReceiptSaleModal";
import DeleteConfirmation from "../Modal/DeleteConfirmation";
import Select from "react-select";
import moment from "moment";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { Box, Button, MenuItem } from "@mui/material";
// import { Box, Button } from "@mui/material";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { toastSuccess } from '../../../../common/Toast';
// import { DELETE_MESSAGE } from '../../../../common/Constant';

let PERMISSION_EDIT = "/manage-customers/:id";
let PERMISSION_DELETE = "delete-customers";

const Customerlisting = ({ listid, customerid }) => {
  // console.log(listid)
  // console.log(customerid)

  const options = [
    { label: "All", value: 1 },
    { label: "Today", value: 7 },
    { label: "Last Day", value: 8 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const [data, setData] = useState([]);
  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(25);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [sortingId, setSortingId] = useState(3);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [customerID, setCustomerID] = useState(0);
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const [pagenumber, setPageNumber] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [filtertext, setFilterText] = useState("");
  const [ordercolumn, setOrderColumn] = useState("");
  const [currentorder, setCurrentOrder] = useState("");
  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [saletype, setSaletype] = useState([]);
  const [salesTypeValue, setSalesTypeValue] = useState();

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype.map((u, i) => {
    salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
  });

  const handleChangeSalesType = (event) => {
    // setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerid,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const deleteRequestParam = localStorage.getItem("DeleteRequestParam");

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const navigate = useNavigate();

  const handleChangeCustomStartingDate = (event) => {
    console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const handleQuickBookChange = (event) => {
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
      console.log(
        "lastWeekStartDate: " + lastWeekStartDate,
        "| " + "lastWeekEndDate" + lastWeekEndDate
      );

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const firstdate = moment().startOf("month").format("YYYY-MM-DD");
      const lastdate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(firstdate);
      setEndingDate(lastdate);
    } else if (event?.value == 7) {
      setStartingDate(moment().startOf("day").format("YYYY-MM-DD"));
      setEndingDate(moment().startOf("day").format("YYYY-MM-DD"));
    } else if (event?.value == 8) {
      const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
      setStartingDate(yesterday);
      setEndingDate(yesterday);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };

  const formatDate = (string) => {
    return moment(string).format("YYYY-DD-MM");
  };

  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      saleids: pID || selectedSalesCheckboxIds,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
  };

  let column1 = useMemo(() => [
    {
      header: "Transaction Date",
      accessorKey: "TransactionDate",
      Cell: ({ row }) => {
        return moment(row.original.TransactionDate).format("DD-MM-YYYY");
      },
    },
    {
      header: "Sale Type",
      accessorKey: "SaleType",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "Location",
      accessorKey: "Location",
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) => {
        return moment(row.original.CreatedDate).format("DD-MM-YYYY");
      },
    },
    {
      header: "CR/DR",
      accessorKey: "TransactionType",
    },
  ]);

  let column2 = useMemo(() => [
    {
      header: "Invoice No",
      accessorKey: "InvoiceNo",
      Cell: ({ row }) => (
        <>
          <Link
            className="text-warning word-break-data"
            to={`/sales-receipt/${row.original.ID}`}
          >
            {row.original.InvoiceNo}
          </Link>
        </>
      ),
    },
    {
      header: "Date",
      accessorKey: "Saletime",
      Cell: ({ row }) => {
        return moment(row.original.Saletime).format("DD-MM-YYYY HH:mm:ss");
      },
    },
    {
      header: "Type",
      accessorKey: "SalesType",
    },
    {
      header: "Status",
      accessorKey: "StatusName",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      Cell: ({ row }) => {
        return row.original.DueDate == null ||
          row.original.DueDate == "0000-00-00"
          ? ""
          : formatDate(row.original.DueDate);
      },
    },
    {
      header: "Aging",
      accessorKey: "Aging",
    },
    {
      header: "Total",
      accessorKey: "Total",
      Cell: ({ row }) => Number(row.original.Total).toFixed(2),
    },
    {
      header: "Amount Due",
      accessorKey: "Amount Due",
      Cell: ({ row }) => Number(row.original.AmountDue).toFixed(2),
    },
  ]);

  const downloadPDF = (rows, field) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = data;
    }
    console.log(newData, "newData");

    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">Invoice No</th>' +
        '<th style="padding: 7px;">Date</th>' +
        '<th style="padding: 7px;">Sales Type</th>' +
        '<th style="padding: 7px;">Status</th>' +
        '<th style="padding: 7px;">Customer</th>' +
        '<th style="padding: 7px;">Total</th>' +
        '<th style="padding: 7px; text-align: right;">Payment Amount</th>' +
        // '<th style="padding: 7px; text-align: right;">CreditApplied</th>' +
        // '<th style="padding: 7px; text-align: right;">AmountDue</th>' +
        // '<th style="padding: 7px; text-align: right;">Location</th>' +
        '<th style="padding: 7px; text-align: right;">DueDate</th>' +
        // '<th style="padding: 7px; text-align: right;">Aging</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].InvoiceNo +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(newData[index - 1].Saletime).format("DD-MM-YYYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].SalesType +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].StatusName +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].CustomerName +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            Number(newData[index - 1].Total).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Paymentamount +
            "</td>" +
            // '<td style="font-size: 7px; padding: 7px;">' +
            // newData[index - 1].CreditApplied +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            // Number(newData[index - 1].AmountDue).toFixed(2) +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            // newData[index - 1].Location +
            // "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            (newData[index - 1].DueDate != undefined &&
            newData[index - 1].DueDate != "0000-00-00"
              ? moment(newData[index - 1].DueDate).format("DD-MM-YYYY")
              : "") +
            "</td>" +
            // '<td style="font-size: 7px; padding: 7px;">' +
            // newData[index - 1].Aging +
            // "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Customer_List.pdf");
        setLoading(false);
      },
    });
  };

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Customer_Listing_.xlsx`);
  };

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Customer_Listing_.xlsx`);
  };

  // let columns = [];
  // if (listid == 4) {
  //   columns = [
  //     {
  //       name: "No",
  //       selector: (row, index) => index + 1,
  //       sortable: false,
  //       width: "80px",
  //     },
  //     {
  //       name: "Transaction Date",
  //       selector: (row) => formatDate(row.TransactionDate),
  //       sortable: true,
  //       // width: "120px",
  //     },
  //     {
  //       name: "Sale Type",
  //       selector: "SaleType",
  //       sortable: true,
  //       // width: "120px",
  //     },
  //     {
  //       name: "Amount",
  //       selector: "Amount",
  //       sortable: true,
  //       // width: "145px",
  //       cell: (row) => (
  //         <div style={{ textAlign: "right", width: "80px" }}>{row.Amount}</div>
  //       ),
  //     },
  //     {
  //       name: "Location",
  //       selector: (row) => row.Location,
  //       sortable: true,
  //       // width: "120px",
  //     },
  //     {
  //       name: "Created Date",
  //       selector: (row) => formatDate(row.CreatedDate),
  //       sortable: true,
  //       // width: "145px",
  //     },
  //     {
  //       name: "CR/DR",
  //       selector: "TransactionType",
  //       sortable: true,
  //       // width: "120px",
  //     },
  //   ];
  // } else {
  //   columns = [
  //     {
  //       name: "Action",
  //       cell: (row) => (
  //         <div class="btn-group-sm" role="group">
  //           {checkUserPermission(PERMISSION_EDIT) ? (
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/manage-sales/${row.ID}`}
  //               style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //             >
  //               Edit
  //             </Link>
  //           ) : (
  //             ""
  //           )}
  //           <button
  //             type="button"
  //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //             data-bs-toggle="dropdown"
  //             aria-haspopup="true"
  //             aria-expanded="false"
  //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //           >
  //           </button>
  //           <div className="dropdown-menu">
  //             {checkUserPermission(PERMISSION_DELETE) ? (
  //               <li>
  //                 <Link
  //                   className="dropdown-item confirm-text"
  //                   to="#"
  //                   title="Delete"
  //                   data-bs-toggle="modal"
  //                   data-bs-target="#DeleteConfirmationModal"
  //                   onClick={() => handleDeletePopup(row.Id)}
  //                 >
  //                   <i
  //                     className="fa fa-trash"
  //                     data-bs-toggle="tooltip"
  //                     title="Delete"
  //                   ></i>&nbsp;Delete
  //                 </Link>
  //               </li>
  //             ) : (
  //               ""
  //             )}
  //             <li>
  //               <Link
  //                 className="dropdown-item me-3"
  //                 to={`/sales-receipt/${row.ID}`}
  //               >
  //                 <i className="fa fa-file"></i>&nbsp;Receipt
  //               </Link>
  //             </li>
  //           </div>
  //         </div>
  //       )
  //     },
  //     // {
  //     //   name: "Sr No",
  //     //   selector: (row, index) => index + 1,
  //     //   sortable: false,
  //     //   width: "80px",
  //     // },
  //     {
  //       name: "Invoice No",
  //       selector: "InvoiceNo",
  //       sortable: true,
  //       width: "130px",
  //     },
  //     {
  //       name: "Date",
  //       selector: (row) => formatDate(row.Saletime),
  //       sortable: true,
  //       width: "150px",
  //     },
  //     {
  //       name: "Type",
  //       selector: "SalesType",
  //       sortable: true,
  //       width: "100px",
  //     },
  //     {
  //       name: "Status",
  //       selector: "StatusName",
  //       sortable: true,
  //       width: "130px",
  //     },
  //     {
  //       name: "Due Date",
  //       selector: (row) => row.DueDate == null || row.DueDate == "0000-00-00" ? "" : formatDate(row.DueDate),
  //       sortable: true,
  //       width: "180px",
  //     },
  //     {
  //       name: "Aging",
  //       selector: "Aging",
  //       sortable: true,
  //       width: "100px",
  //       // cell: (row) => (row.Aging > 0 ? row.Aging : ""),
  //     },
  //     {
  //       name: "Total",
  //       selector: (row) => Number(row.Total).toFixed(2),
  //       right: true,
  //       sortable: true,
  //       width: "150px",
  //     },
  //     {
  //       name: "Amount Due",
  //       selector: (row) => Number(row.AmountDue).toFixed(2),
  //       right: true,
  //       sortable: true,
  //       width: "150px",
  //     },
  //     // {
  //     //   name: "Receipt",
  //     //   width: "150px",
  //     //   sortable: false,
  //     //   cell: (row) => (
  //     //     <Link
  //     //       className="btn btn-sm btn-outline-primary"
  //     //       to={`/sales-receipt/${row.ID}`}
  //     //     >
  //     //       <i className="fa fa-file"></i> Receipt
  //     //     </Link>
  //     //   ),
  //     // },
  //     // {
  //     //   name: "Action",
  //     //   width: "150px",
  //     //   sortable: true,
  //     //   cell: (row) => (
  //     //     <>
  //     //       {checkUserPermission(PERMISSION_EDIT) ? (
  //     //         <Link className="me-3" to={`/manage-sales/${row.ID}`}>
  //     //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //     //         </Link>
  //     //       ) : (
  //     //         ""
  //     //       )}
  //     //       {checkUserPermission(PERMISSION_DELETE) ? (
  //     //         <Link
  //     //           className="confirm-text"
  //     //           to="#"
  //     //           title="Delete"
  //     //           data-bs-toggle="modal"
  //     //           data-bs-target="#DeleteConfirmationModal"
  //     //           onClick={() => handleDeletePopup(row.Id)}
  //     //         >
  //     //           <i
  //     //             className="fa fa-trash text-red fa-2x"
  //     //             data-bs-toggle="tooltip"
  //     //             title="Delete"
  //     //           ></i>
  //     //         </Link>
  //     //       ) : (
  //     //         ""
  //     //       )}
  //     //     </>
  //     //   ),
  //     //   ignoreRowClick: true,
  //     //   allowOverflow: true,
  //     //   button: true,
  //     // },
  //   ];
  // }

  // Styles

  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      color: "#000",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      color: state.isActive ? "#000" : "#000",
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        color: "#000",
        backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
      },
    }),
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      searchtext,
      e.id,
      sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerid,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const contextActions = useMemo(() => {
    const handleDeletePopup = (pID) => {
      const deleteRequestParam = {
        saleids: selectedSalesCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [selectedRows, toggleCleared]);

  useEffect(() => {
    setLoading(true);

    // if (listid === 1) {
    //   setTitle("Invoice");
    // }
    // if (listid === 2) {
    //   setTitle("Return / Memo");
    // }
    // if (listid === 3) {
    //   setTitle("Estimates");
    // }
    // if (listid === 4) {
    //   setTitle("Customer Account");
    // }
    // if (listid === 5) {
    //   setTitle("Received Payments");
    // }

    // if (quickBookOptions?.value !== 2) {
    handleListData(
      pagenumber,
      perPageSize,
      filtertext,
      ordercolumn,
      currentorder,
      startingDate,
      endingDate,
      salesTypeID,
      customerid,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
    // }
  }, [
    listid,
    salesTypeID,
    customerid,
    quickBookOptions,
    sorting,
    pagination,
    globalFilter,
    columnFilters,
  ]);

  useEffect(() => {
    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  console.log("Data1", data);

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate,
    salestypeid,
    customerid,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    salestypeid = salestypeid > 0 ? salestypeid : 0;
    customerid = customerid > 0 ? customerid : 0;

    let columnIndex;
    salesTypeID === 4
      ? (columnIndex = column1.findIndex(
          (column) => column.accessorKey === sorting[0]?.id
        ))
      : (columnIndex = column2.findIndex(
          (column) => column.accessorKey === sorting[0]?.id
        ));

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    if (salesTypeID == 4) {
      axios
        .get(
          `${
            config.customersBaseUrl
          }/customers/cusomerstoreaccountlist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
            sorting[0]?.desc === undefined
              ? "desc"
              : sorting[0]?.desc === true
              ? "desc"
              : "asc"
          }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
            pagination.pageSize
          }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
            globalFilter === undefined ? "" : globalFilter
          }&startdate=${
            startingdate === undefined ? "" : startingdate
          }&enddate=${
            endingdate === undefined ? "" : endingdate
          }&salestypeid=${salestypeid}&customerid=${customerid}&LocationID=${localStorage.getItem(
            "Location"
          )}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData);
          setData(res.data.ResponseData);
          setTotalRows(res.data.ResponseData[0]?.TotalRecord);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      axios
        .get(
          `${
            config.salesconfigBaseUrl
          }/sales/saleslist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
            sorting[0]?.desc === undefined
              ? "desc"
              : sorting[0]?.desc === true
              ? "desc"
              : "asc"
          }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
            pagination.pageSize
          }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
            globalFilter === undefined ? "" : globalFilter
          }&status=0&startdate=${
            startingdate === undefined ? "" : startingdate
          }&enddate=${
            endingdate === undefined ? "" : endingdate
          }&salestypeid=${salestypeid}&customerid=${customerid}&LocationID=${localStorage.getItem(
            "Location"
          )}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData);
          setData(res.data.ResponseData);
          setTotalRows(res.data.ResponseData[0]?.TotalRecord);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  // useEffect(() => {
  //   if (quickBookOptions?.value == 1) {
  //     setStartingDate("");
  //     setEndingDate("");
  //   }
  //   // Custom Condition
  //   // else if (quickBookOptions?.value == 2) {
  //   //   setStartingDate(customStartingDate);
  //   //   setEndingDate(customEndingDate);
  //   // }
  //   // Last Week Condition
  //   else if (quickBookOptions?.value == 3) {
  //     const lastWeekStartDate = moment()
  //       .subtract(1, "week")
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const lastWeekEndDate = moment()
  //       .subtract(1, "week")
  //       .endOf("week")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastWeekStartDate);
  //     setEndingDate(lastWeekEndDate);
  //   }
  //   // Current Week Condition
  //   else if (quickBookOptions?.value == 4) {
  //     const currentWeekStartDate = moment()
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

  //     setStartingDate(currentWeekStartDate);
  //     setEndingDate(currentWeekEndDate);
  //   }
  //   // Last Month Condition
  //   else if (quickBookOptions?.value == 5) {
  //     const lastMonthStartDate = moment()
  //       .subtract(1, "month")
  //       .startOf("month")
  //       .format("YYYY-MM-DD");
  //     const lastMonthEndDate = moment()
  //       .subtract(1, "month")
  //       .endOf("month")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastMonthStartDate);
  //     setEndingDate(lastMonthEndDate);
  //   }
  //   //currentmonth
  //   else if (quickBookOptions?.value == 6) {
  //     const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
  //     const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

  //     setStartingDate(currentFirstDate);
  //     setEndingDate(currentLastDate);
  //   } else {
  //     setStartingDate("");
  //     setEndingDate("");
  //   }
  // }, [quickBookOptions]);

  // useEffect(() => {
  //   if (quickBookOptions?.value !== 2) {
  //     handleListData(
  //       1,
  //       perPageSize,
  //       searchtext,
  //       sortingId,
  //       sortingDirection,
  //       startingDate,
  //       endingDate,
  //       salesTypeID,
  //       customerID
  //     );
  //   }
  // }, [salesTypeID, customerID, quickBookOptions]);

  console.log(data, "data457");

  return (
    <>
      {/* Invoice data */}

      <div className={"col-lg-10 col-md-12"}>
        <div className="card bg-white">
          <div className="d-flex w-100 mr-2 mt-2 ">
            {/* <div className="d-flex flex-wrap">  */}
            {/* <div className="p-3 col-lg-3 col-md-6 col-sm-12 pt-4  h-25">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-100 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div> */}
            <div className="p-1 col-lg-3 col-md-6 col-sm-12">
              Date Filter:
              <Select
                defaultValue={quickBookOptions}
                onChange={(event) => {
                  handleQuickBookChange(event);
                }}
                options={options}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                // hideSelectedOptions={true}
                styles={selectStyles}
                className="custom-search-select"
              />
            </div>
            {quickBookOptions?.value == 2 && (
              <>
                <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                  Custom Start Date:
                  <input
                    type="date"
                    className="form-control mt-1"
                    id="StartDate"
                    name="StartDate"
                    onChange={(event) => handleChangeCustomStartingDate(event)}
                  />
                </div>
                <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                  Custom End Date:
                  <input
                    type="date"
                    className="form-control mt-1"
                    id="EndDate"
                    name="EndDate"
                    onChange={(event) => handleChangeCustomEndingDate(event)}
                  />
                </div>
              </>
            )}
            {quickBookOptions?.value == 2 && (
              <div className="p-1 col-lg-1 col-md-6 col-sm-12 mt-4">
                <button
                  className="btn btn-dark"
                  onClick={() => handleSearchAccordingToDate()}
                >
                  {" "}
                  Search{" "}
                </button>
              </div>
            )}

            <div className="p-1 col-lg-3 col-md-6 col-sm-12">
              Sales Type:
              <Select
                defaultValue={salesTypeValue}
                onChange={(event) => {
                  handleChangeSalesType(event);
                }}
                options={salesTypeDropdownOption}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                styles={selectStyles}
                className="custom-search-select "
              />
            </div>
            {/* justify-content-flex-end  flex-row-reverse */}

            {/* </div>   */}
          </div>

          {/* </div> */}

          {/* <div className="row mt-2"> */}

          {/* <div className="card-body ">
            <div className="email-header">
              <div className="row">
                <div className="col-lg-15 top-action-left col-sm-20  ">
                  <div className="float-left table-responsive">
                    <DataTable
                      title={title}
                      columns={columns}
                      data={data}
                      progressPending={loading}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationDefaultPage={currentPage}
                      onChangeRowsPerPage={(e) => {
                        handlePerRowsChange(1, e);
                      }}
                      onChangePage={handlePageChange}
                      highlightOnHover
                      striped
                      responsive
                      paginationRowsPerPageOptions={[25, 50, 100, 500]}
                      persistTableHead
                      sortServer
                      onSort={handleSort}
                      contextActions={contextActions}
                      clearSelectedRows={toggleCleared}
                      dense
                      defaultSortAsc={false}
                      defaultSortField="timestamp"
                      paginationPerPage={perPageSize}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* {
            listid === 4?
            (
              <MaterialReactTable
            columns={column1}
            data={data}
            enableColumnResizing
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            // enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "compact",
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            muiTablePaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: 'fit-content' } }}
            // manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                  color: 'error',
                  children: 'Error loading data',
                }
                : undefined
            }
            // onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              // columnFilters,
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
            ):
            (
              <MaterialReactTable
               columns={column2}
               data={data}
               enableColumnResizing
                 renderRowActionMenuItems={({ row }) =>
                   [
                     (checkUserPermission(PERMISSION_EDIT)) ?
                       (<MenuItem key="edit" onClick={() => navigate(`/manage-sales/${row.original.ID}`)}>
                         Edit
                       </MenuItem>) : "",
                     <MenuItem
                       className="confirm-text"
                       to="#"
                       // key="delete"
                       title="Delete"
                       data-bs-toggle="modal"
                       data-bs-target="#DeleteConfirmationModal"
                       onClick={() => handleDeletePopup(row.original.ID)}
                     >
                       Delete
                     </MenuItem>,
                   ]
                 }
               enableGrouping
               enableStickyHeader
               enableStickyFooter
               enableRowSelection={}
               enableColumnOrdering
               initialState={{
                 density: "compact",
                 expanded: true, //expand all groups by default
                 // grouping: [""], //an array of columns to group by by default (can be multiple)
                 pagination: { pageIndex: 0, pageSize: 25 },
                 sorting: [{ id: "state", desc: false }], //sort by state by default
               }}
               // muiToolbarAlertBannerChipProps={{ color: "primary" }}
               // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
               muiTablePaginationProps={{
                 rowsPerPageOptions: [25, 50, 100, 300, 500],
               }}
               muiTableContainerProps={{ sx: { maxHeight: 'fit-content' } }}
               // manualFiltering
               manualPagination
               manualSorting
               muiToolbarAlertBannerProps={
                 isError
                   ? {
                     color: 'error',
                     children: 'Error loading data',
                   }
                   : undefined
               }
               // onColumnFiltersChange={setColumnFilters}
               onGlobalFilterChange={setGlobalFilter}
               onPaginationChange={setPagination}
               onSortingChange={setSorting}
               rowCount={totalRows}
               state={{
                 // columnFilters,
                 globalFilter,
                 isLoading,
                 pagination,
                 showAlertBanner: isError,
                 showProgressBars: isRefetching,
                 sorting,
               }}
             />
            )
           }
            */}
          {/* Receipt */}
          <div className="container" style={{ display: "none" }}>
            <div className="col-md-12 text-center" id="header">
              <h2>Jarkan</h2>
              <p className="fw-bold">Customer List</p>
              <div className="row">
                {(customStartingDate || customEndingDate) && (
                  <>
                    <p>
                      Date: {customStartingDate} to {customEndingDate}
                    </p>
                  </>
                )}
              </div>
            </div>
            <hr />
          </div>

          <MaterialReactTable
            columns={salesTypeID === 4 ? column1 : column2}
            data={data}
            enableColumnResizing
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            // enableRowSelection={salesTypeID === 4 ? false : true}
            enableColumnOrdering
            initialState={{
              density: "compact",
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            muiTablePaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
            // manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Error loading data",
                  }
                : undefined
            }
            // onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              // columnFilters,
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
            renderRowActionMenuItems={
              listid === 4
                ? false
                : ({ row }) => [
                    checkUserPermission(PERMISSION_EDIT) ? (
                      <MenuItem
                        key="edit"
                        onClick={() =>
                          navigate(`/manage-sales/${row.original.ID}`)
                        }
                      >
                        Edit
                      </MenuItem>
                    ) : (
                      ""
                    ),
                    <MenuItem
                      className="confirm-text"
                      to="#"
                      // key="delete"
                      title="Delete"
                      data-bs-toggle="modal"
                      data-bs-target="#DeleteConfirmationModal"
                      onClick={() => handleDeletePopup(row.original.ID)}
                    >
                      Delete
                    </MenuItem>,
                  ]
            }
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                {console.log(table, "tables")}

                <Button
                  size="small"
                  color="primary"
                  //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                  onClick={onBtExport}
                  startIcon={<FileDownloadIcon />}
                  variant="contained"
                >
                  Export All In Excel
                </Button>
                <Button
                  size="small"
                  disabled={
                    !table.getIsSomeRowsSelected() &&
                    !table.getIsAllRowsSelected()
                  }
                  //only export selected rows
                  onClick={() =>
                    handleExportRows(table.getSelectedRowModel().rows)
                  }
                  startIcon={<FileDownloadIcon />}
                  variant="contained"
                >
                  Export Selected Rows in Excel
                </Button>
                <Button
                  size="small"
                  color="primary"
                  //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                  onClick={() => downloadPDF("", "alldata")}
                  startIcon={<FileDownloadIcon />}
                  variant="contained"
                >
                  Export All In Pdf
                </Button>
                <Button
                  size="small"
                  disabled={
                    !table.getIsSomeRowsSelected() &&
                    !table.getIsAllRowsSelected()
                  }
                  //only export selected rows
                  onClick={() =>
                    downloadPDF(table.getSelectedRowModel().rows, "selectedrow")
                  }
                  startIcon={<FileDownloadIcon />}
                  variant="contained"
                >
                  Export Selected Rows in Pdf
                </Button>
              </Box>
            )}
          />
        </div>
      </div>

      <DeleteConfirmation
        deleteApiUrl={`${config.salesconfigBaseUrl}/sales/batchdelete`}
      />
      <LookupReceiptSaleModal />
    </>
  );
};

export default Customerlisting;
